import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface DashboardReflowState {
    rand: number
}

export const useDashboardReflowStore = create<DashboardReflowState>()(
    devtools(
        (set) => ({
            rand: 0,
        }),
        {
            name: 'AccessoryDrawerStore',
        },
    ),
)

export const triggerDashboardReflow = () => useDashboardReflowStore.setState({ rand: Math.random() })
